/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};
  const rawAccess = currentUser?.access;

  const accessMap: Record<string, boolean> = {};
  const accessList: string[] = [];

  if (Array.isArray(rawAccess)) {
    rawAccess.forEach((code) => {
      if (code) {
        accessMap[code] = true;
        accessList.push(code);
      }
    });
  } else if (rawAccess) {
    accessMap[rawAccess] = true;
    accessList.push(rawAccess);
  }

  // 提取路径前缀用于匹配动态路由
  // 例如 /channel/account/xiaomi -> /channel/account
  const pathPrefixes = new Set<string>();
  accessList.forEach((path) => {
    const parts = path.split('/').filter(Boolean);
    if (parts.length >= 2) {
      pathPrefixes.add(`/${parts[0]}/${parts[1]}`);
    }
  });

  return {
    canAdmin: accessMap['admin'] === true,
    ...accessMap,
    // 检查是否有 /channel/account/* 的任意权限
    channelAccountAccess: pathPrefixes.has('/channel/account'),
    // 检查是否有 /channel/report/* 的任意权限
    channelReportAccess: pathPrefixes.has('/channel/report'),
    // 检查是否有 /channel/rebateConfig/* 的任意权限
    channelRebateConfigAccess: pathPrefixes.has('/channel/rebateConfig'),
  };
}
